<template>
  <v-container fluid
               v-if="contact">
    <div class="d-flex align-center pb-3">
      <div class="display-1">
        Edit Contact
      </div>
    </div>
    <v-form @submit.prevent="submit"
            autocomplete="off">
      <v-card>
        <v-card-text>
          <user-contact-form :contact="contact"
                             :form="form">
          </user-contact-form>
        </v-card-text>
        <v-card-actions>
          <v-btn type="submit"
                 color="primary">
            Submit
          </v-btn>

          <v-btn :to="{name: `${$root.routePrefix}.user_contacts.index`}">
            Cancel
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-container>
</template>
<script>
import userContactService from '../../services/userContactService';
import {Form} from 'vform';
import formValidation from '../../plugins/formValidation';
import UserContactForm from './components/UserContactForm';
import DOMPurify from 'dompurify';

export default {
  components: {UserContactForm},
  mixins: [formValidation],
  data() {
    return {
      contact: null,
      form: new Form(userContactService.initForm()),
    }
  },
  computed: {
    contactID() {
      return parseInt(this.$route.params.contactID);
    },
  },
  created() {
    this.fetchData();
  },
  methods: {
    fetchData() {
      userContactService.getContact(this.contactID)
        .then(data => {
          this.contact = data;
          userContactService.populateForm(this.contact, data);
        })
        .catch(err => {
          this.$toast.error(`Contact ${DOMPurify.sanitize(this.contactID)} not found`);
          if (this.$root.isAdminRoute) {
            this.$router.replace({name: 'admin.user_contacts.index'});
          } else {
            this.$router.replace({name: `${this.$root.routePrefix}.user_contacts.index`});
          }
        })
    },
    submit() {
      this.form.put(`/api/user-contacts/${this.contactID}`)
        .then(response => {
          this.$router.push({name: `${this.$root.routePrefix}.user_contacts.index`});
        })
    },
  }
}
</script>
